// src/components/signage/TodayCampaignsList.jsx
//
// "Rotativo de hoy" — lists every campaign scheduled for today in the
// order returned by the backend (DisplayOrder ASC, Id ASC). The admin
// sees the full picture the kiosk is playing.
//
// Inner scroll bounded to 540 px so the Estado tab itself stays
// compact even when the day has 5+ campaigns. When `today` is empty,
// renders a single-card message pointing to the Campañas tab.

import React from 'react';
import { Button, Tag, Empty } from 'antd';
import { BsPlayCircle } from 'react-icons/bs';
import CampaignPreview from './CampaignPreview';
import './TodayCampaignsList.css';

export default function TodayCampaignsList({ today = [], onPlay, onEdit, onJumpToCampanas }) {
    if (!today || today.length === 0) {
        return (
            <div className="today-campaigns">
                <h4 className="today-campaigns__title">Rotativo de hoy</h4>
                <div className="today-campaigns__empty">
                    <Empty
                        description="No hay campañas programadas para hoy. Configurá los días desde Campañas."
                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                    >
                        {onJumpToCampanas && (
                            <Button type="primary" onClick={onJumpToCampanas}>
                                Ir a Campañas
                            </Button>
                        )}
                    </Empty>
                </div>
            </div>
        );
    }

    return (
        <div className="today-campaigns">
            <h4 className="today-campaigns__title">
                Rotativo de hoy <Tag color="blue">{today.length}</Tag>
            </h4>
            <div className="today-campaigns__list">
                {today.map((c, i) => (
                    <div className="today-campaign-card" key={c.id}>
                        <div className="today-campaign-card__header">
                            <div className="today-campaign-card__title">
                                <span className="index">{i + 1}.</span>
                                <strong>{c.name}</strong>
                            </div>
                            <div className="today-campaign-card__actions">
                                <Button
                                    size="small"
                                    icon={<BsPlayCircle />}
                                    onClick={() => onPlay?.(c)}
                                >
                                    Reproducir
                                </Button>
                            </div>
                        </div>
                        <div className="today-campaign-card__meta">
                            <span>{c.slidesCount || (c.slides || []).length || 0} diapositivas</span>
                            {c.orientation && (
                                <Tag color="default" style={{ marginLeft: 8 }}>
                                    {c.orientation === 'portrait' ? 'Vertical' : 'Horizontal'}
                                </Tag>
                            )}
                            <Tag color="green" style={{ marginLeft: 8 }}>En horario</Tag>
                        </div>
                        <div className="today-campaign-card__preview">
                            <CampaignPreview campaign={c} compact maxWidth={240} />
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
